export const environment = {
  production: false,
  //_ep: false,
  //_er: true,
  //_ear: false,
  encryptPassword: false,
  encryptRequest: true,
  encryptAdminApiRequest: true,
  clientUrl : 'https://lend-uat.jiopayment.ezeefin.net.in/consumerAPI',
  adminUrl : 'https://lend-uat.jiopayment.ezeefin.net.in/adminAPI',
  domain : 'https://lend-uat.jiopayment.ezeefin.net.in/campaign',  // Domain on which the application will be deployed
  testUrl: 'https://lend-uat.jiopayment.ezeefin.net.in/consumerAPI',
  notificationUrl: 'https://lend-uat.jiopayment.ezeefin.net.in',
  uamRedirectUrl: 'https://lend-uat.jiopayment.ezeefin.net.in',
  loginUrl: 'https://lend-uat.jiopayment.ezeefin.net.in/auth/realms/ezee/protocol/openid-connect/auth?client_id=ezee-client&response_type=code&state=fj8o3n7bdy1op5&redirect_uri=https://lend-uat.jiopayment.ezeefin.net.in/campaign',
  decisionEngineUrl: 'https://lend-uat.jiopayment.ezeefin.net.in/decisionEngine',
  videoConferenceUrl: '',
  lookupUrl:'https://lend-uat.jiopayment.ezeefin.net.in/lookupAPI',
  //_vcu: 'wss://identify.sandboxforbank.com/janus/',
  postVideoConferenceUrl: '',
  videoRecordingPath: '',
  googleApiKey: '',
  //_gak: 'AIzaSyBzwS19hAwa6qsSWb0BtMhcmUuovg8m6_o',
  videoConferenceICEServers: '',
  customerUserPassword: "13232e0442360b3bca1033a3b3c5cc18:1291db1dc2832049f2330408a3a079fa",
  //_cup: "13232e0442360b3bca1033a3b3c5cc18:1291db1dc2832049f2330408a3a079fa"
   headingFontFamily:'Jio',
  contentFontFamily:'Jio-Medium',
  globalFontSizeContent:'16px', 
  immediatePreview: false,
  vishwam_app_id: 'jpb',
  vishwamSdkUrl: "https://apis-jpb-stag.vishwamcorp.com/v1",
  eid: "ezee",
  repaymentApiKey:"",
  repaymentUrl: "",
  mid: "",
  adminV2Url:'https://lend-uat.jiopayment.ezeefin.net.in/adminAPI',
  entityId:"JPB",
  docHubAPIBaseUrl: "https://lend-uat.jiopayment.ezeefin.net.in/docHubAPI",
  orgAPIBaseUrl: 'https://lend-uat.jiopayment.ezeefin.net.in/orgManageAPI',
  enableCompressedWidth: true,
  finvuWebSocketUrl: "wss://webvwdev.finvu.in/consentapi",
  repaymentCheckoutUrl:"",
  loadingPageUrl: '../assets/images/Resume-screen.svg',
  vkycBannerImgUrl : "",
  changeAccessTokenHeaderName : false,
  loadMoneyCheckoutURL: 'https://sit-jpbpg.test.jiobank.in:8443/2FA',
  
};
